import React, { useState, useEffect } from "react";
import { Column } from "@ant-design/plots";

const GroupColumnChart = ({
  data,
  xLabel,
  colorField,
  color,
  xField,
  yField,
}) => {
  const [chartColor, setChartColor] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    if (color == "participation") {
      setChartColor(["#37948e", "#2e84bf"]);
    } else if (color == "event_organizer") {
      setChartColor(["#2e84bf", "#37948e", "#4863A0", "#4E5180"]);
    } else {
      setChartColor([
        "#2e84bf",
        "#37948e",
        "#593055",
        "#e4857e",
        "#67e67d",
        "#ff74c2",
        "#7ca6b4",
        "#4e4e4e",
      ]);
    }
  };

  const config = {
    data: data,
    color: chartColor,
    xField: xField,
    yField: yField,
    colorField: colorField,
    group: true,
    label: {
      text: "value",
      position: "inside",
    },

    minColumnWidth: 10,
    maxColumnWidth: 45,
  };

  return <Column {...config} />;
};

export default GroupColumnChart;
